
import * as React from 'react';
import { observer } from 'mobx-react';

interface IIfProps {
	condition: boolean | undefined;
	children: React.ReactNode;

}

/**
 * @deprecated
 */
@observer
export default class If extends React.Component<IIfProps> {
	public render() {
		const { condition, children } = this.props;

		if (condition) {
			return children;
		}

		return null;
	}
}
